<template>
  <div class="layout-content">
    <div class="tool">
      <Row :gutter="20">
        <Col span="12">
        <div class="tool-item">
          <Icon type="ios-alert-outline" /> 直播暂存视频文件只保留180天，如需永久保留请转存至回放列表
        </div>
        </Col>
        <Col span="12">
        <div class="tool-item right">
          <Button type="primary" ghost shape="circle" @click="Refresh">刷新</Button>
          <Button type="primary" ghost shape="circle" @click="addToView">添加至回放列表</Button>
        </div>
        </Col>
      </Row>
    </div>
    <div v-if="contents.length">
      <Table ref="selection" :columns="columns" :data="contents" @on-selection-change="changeEvent">
        <template slot-scope="{ row }" slot="originSessionId"><span>{{ row.originSessionId }} 2323</span></template>
        <template slot-scope="{ row }" slot="startTime">{{ row.startTime | time_sort4  }}</template>
        <template slot-scope="{ row }" slot="recordFileType">
          <span v-if="row && row.recordFileType === 'complete'">完整回放</span>
          <span v-if="row && row.recordFileType === 'part'">自动录制片段</span>
          <span v-if="row && row.recordFileType === 'merge'">手动合并</span>
          <span v-if="row && row.recordFileType === 'clip'">裁剪</span>
        </template>
        <template slot-scope="{ row }" slot="fileName"><span v-if="row">{{ row.fileName }}</span></template>
        <template slot-scope="{ row }" slot="duration"><span v-if="row">
            {{ row.duration  | time_sort3  }}
          </span></template>
        <template slot-scope="{ row }" slot="daysLeft"><span v-if="row">{{ row.daysLeft }}</span></template>
        <template slot-scope="{ row }" slot="edit">
          <a :href="row.url" v-if="row && row.url" :download="row.flv" target="_blank">下载</a>
          <!-- <Dropdown :transfer="true" v-else>
            <a href="javascript:;">下载</a>
            <DropdownMenu slot="list">
              <DropdownItem v-if="row && row.flv"><a target="_blank" :href="row.flv" :download="row.flv">flv</a></DropdownItem>
              <DropdownItem v-if="row && row.mp4"><a target="_blank" :href="row.mp4" :download="row.mp4">mp4</a></DropdownItem>
              <DropdownItem v-if="row && row.m3u8"><a target="_blank" :href="row.m3u8" :download="row.m3u8">m3u8</a></DropdownItem>
            </DropdownMenu>
          </Dropdown> -->
        </template>
      </Table>
      <div class="my-page" v-if="totalCount > pageSize" style="margin: 20px;text-align: center;">
        <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount" @on-change="changePage" @on-page-size-change="changePageSize" />
      </div>
    </div>
    <div class="u-empty" v-else>暂无数据</div>

    <iModal v-model="modal1" title="转存信息填写">
      <div style="padding: 20px">
        <Input type="text" v-model="inp" placeholder="请输入转存后视频名称" />
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="addToViewHandle">保存</Button>
        <Button @click="cancel()">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'live-staging', // 直播暂存
  data () {
    return {
      loading: false,
      modal1: false,
      inp: '',
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
        },
        {
          title: '场次ID',
          key: 'originSessionId',
          slot: 'originSessionId',
          align: 'center',
        },
        {
          title: '直播开始时间',
          key: 'startTime',
          slot: 'startTime',
          align: 'center',
        },
        {
          title: '视频类型',
          key: 'recordFileType',
          slot: 'recordFileType',
          align: 'center',
        },
        {
          title: '视频名称',
          key: 'fileName',
          slot: 'fileName',
          align: 'center',
        },
        {
          title: '视频时长',
          key: 'duration',
          slot: 'duration',
          align: 'center',
        },
        {
          title: '暂存剩余天数',
          key: 'daysLeft',
          slot: 'daysLeft',
          align: 'center',
        },
        {
          title: '操作',
          slot: 'edit',
          align: 'center',
          width: 200,
        },
      ],
      selection: [], // 选中项目
      contents: [],
    }
  },
  computed: {
    ...mapGetters({
      hostExhibitionId: 'hostSetModule/getHostExhibitionId',
    }),
    option () {
      return {
        activityId: this.activityId,
        page: this.pageIndex,
        size: this.pageSize,
        searchType: 'all',
      }
    },
    activityId () {
      return this.$route.query.activityId;
    },
    channelId () {
      return this.$route.query.channelId;
    },
    refreshOption () {
      return {
        activityId: this.activityId,
        channelId: this.channelId,
      };
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    ...mapActions({
      convertVideo: 'liveModule/convertVideo',
      copyDate: 'liveModule/copyDate',
      getLiveHistoryQuery: 'liveModule/getLiveHistoryQuery',
    }),
    changePage (e) {
      this.pageIndex = e;
      this.init()
    },
    changePageSize (e) {
      this.pageSize = e;
      this.init()
    },
    searchPro () {
      this.pageIndex = 1;
      this.init()
    },
    changeEvent (selection) {
      this.selection = selection;
    },
    async addToView () {
      if (!(this.selection && this.selection.length)) {
        this.$Message.error('请选择视频再进行操作')
        return;
      }
      console.log('selection', this.selection);
      this.modal1 = true;
    },
    async addToViewHandle () {
      this.loading = true;
      if (!this.inp) {
        this.loading = false;
        this.$Message.error('请选择输入转存后视频名称')
        return;
      }
      this.loading = false;
      let arr = []
      this.selection.forEach(c => {
        arr.push({ liveRecordId: c.id, fileIds: c.fileId });
      });
      let opt = {
        fileName: this.inp,
        filds: arr,
      }
      let bool = await this.convertVideo(opt);
      if (bool) {
        this.$Message.success('操作成功！');
        this.cancel();
        setTimeout(c => {
          this.init();
        }, 2000);
      } else {
        this.$Message.success('操作失败！')
      }
    },
    async init () {
      let res = await this.getLiveHistoryQuery(this.option);
      if (res && res.items) {
        res.items.map(c => {
          if (!c.isConvert && c.convertStatus === 'success') {
            c._disabled = true;
          }
          if (c.isConvert) {
            c._disabled = true;
          }
          if (c.startTime && c.endTime) {
            let m1 = c.startTime;
            let m2 = c.endTime;
            let du = moment.duration(m2 - m1, 'ms'),
              hours = du.get('hours'),
              mins = du.get('minutes'),
              ss = du.get('seconds'); 
              console.log(' --- ',hours, mins, ss);
            c.lineTime = this.PrefixInteger(hours, 2) + ':' + this.PrefixInteger(mins, 2) + ':' + this.PrefixInteger(ss, 2)
          }
        });
        this.contents = res.items;
        console.log('liveRecordVideo', this.contents);
        this.totalCount = res.totalCount;
      }
    },
    PrefixInteger (num, n) {
      return (Array(n).join(0) + num).slice(-n);
    },
    async Refresh () {
      let res = await this.copyDate(this.refreshOption);
      if (res) {
        this.$Message.success('刷新成功！')
        return;
      } else {
        this.$Message.error('刷新失败！')

      }
    },
    cancel () {
      this.modal1 = false;
      this.inp = '';
      this.selection = [];
      this.init();
    }
  },
}
</script>

<style scoped lang="scss">
.tool {
  &-item {
    display: flex;
    align-items: center;
    height: 40px;
    padding-bottom: 20px;

    /deep/ {
      .ivu-icon {
        margin-right: 10px;
        position: relative;
        top: -1px;
      }
    }

    &.right {
      justify-content: flex-end;

      /deep/ {
        .ivu-btn {
          margin-left: 20px;
        }
      }
    }
  }
}
</style>

